import React from "react";
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import TagDisplay from "../../../../../../commonComponents/tagDisplay";
import {useLoggedInApi} from "../../../../../../api";
import {useMutation} from "react-query";
import {toast} from "react-toastify";

export default function ConfirmUniqueTagGroupModal({isOpen, toggle, tagDuplicate, tagAutoTag, confirm}) {
    const api = useLoggedInApi()
    const changeTagsMutation = useMutation(() => {
        const tagResource = api.resource('tag/tag')
        const tagIdsToChange = [
            ...tagDuplicate.map(row => row.id),
            ...tagAutoTag.map(row => row.id)
        ]
        const updatePromise = Promise.all(tagIdsToChange.map(tagId => {
            return tagResource.patchItem(tagId, {
                multiple_source: null,
                auto_tag_new: false,
                auto_tag_if_tag_added: null,
                auto_tag_if_taggroup_added: null,
            })
        }))
        toast.promise(updatePromise, {
            pending: `Removing auto-tag and allow duplicates from ${tagIdsToChange.length} tags...`,
            success: `Removed auto-tag and allow duplicates from ${tagIdsToChange.length} tags`,
            error: 'Error Updating Tags'
        })
        return updatePromise;
    }, {
        onSuccess: () => {
            confirm()
            toggle()
        }
    })
    return <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="sm"
        centered
        scrollable={true}
    >
        <ModalHeader toggle={toggle} className="activegroup-header"></ModalHeader>
        <ModalBody>
            <h5>Confirm tag group change type to unique?</h5>
            <p>
                This tag group has tags with {" "}
                <TagDisplay color={'rosybrown'}>
                    ALLOW DUPLICATE TAGS
                </TagDisplay>
                {" "} or {" "}
                <TagDisplay color={'burlywood'}>
                    AUTO TAG
                </TagDisplay>
                {" "} settings. To change this tag group to unique, the following tags will be updated.
            </p>

            <p>
                {
                    tagDuplicate?.map(row => {
                        return <TagDisplay key={row.id} color={row.color}>
                            {row.name}
                        </TagDisplay>
                    })
                }
                {
                    tagAutoTag?.map(row => {
                        return <TagDisplay key={row.id} color={row.color}>
                            {row.name}
                        </TagDisplay>
                    })
                }
            </p>
        </ModalBody>
        <ModalFooter>
            <Row>
                <Col className="text-end">
                    <Button color="primary text-white" onClick={() => {
                        changeTagsMutation.mutate()
                    }}>
                        CONFIRM
                    </Button>
                    <Button color={'secondary'} onClick={toggle}>
                        CANCEL
                    </Button>
                </Col>
            </Row>
        </ModalFooter>
    </Modal>
}